import React from 'react';
import ReactDOM from 'react-dom';
import {ManageFavouritesApp} from "./apps/ManageFavouritesApp";

let manageFavouritesRoots = document.getElementsByClassName('manageFavouritesRoot');

[].forEach.call(manageFavouritesRoots, function(manageFavouritesRoot){

    const siteKey = manageFavouritesRoot.getAttribute('data-sitekey');
    const printBaseUrl = manageFavouritesRoot.getAttribute('data-print-base-url');
    const printUrl = manageFavouritesRoot.getAttribute('data-print-url');

    ReactDOM.render(
		<ManageFavouritesApp reCaptchaSiteKey={siteKey} printBaseUrl={printBaseUrl} printUrl={printUrl} />,
        manageFavouritesRoot
    );
});


// WEBPACK FOOTER //
// ./src/manageFavourites.js